import { useCallback, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'

import {
  AddMerchantBankAccountTypes,
  AddMerchantBankAccountFormTypes,
  AddMerchantBankAccountFormSubmitValuesTypes,
  AddMerchantBankAccountFormSubmitActionsTypes,
} from 'types/merchant'

import useMerchantStore from 'store/merchant'

const ADDMERCHANTBANKACCOUNTSINITVAL: AddMerchantBankAccountTypes = {
  traderId: 0,
  bankAccountNumber: 0,
  bankAccountTypeId: 1,
  name: '',
  expiryDate: '',
  safetyCode: null,
  payerPartyCode: '',
  payerPartyParticulars: '',
  payeePartyRef: '',
  payeePartyCode: '',
  payeePartyParticulars: '',
  isDefaultBankAccount: 0,
}

const ADDMERCHANTBANKACCOUNTSINITVAL_FORM: AddMerchantBankAccountFormTypes = {
  traderId: 0,
  bankAccountNumber: '',
  bankAccountTypeId: 1,
  name: '',
  expiryDate: '',
  safetyCode: null,
  payerPartyCode: '',
  payerPartyParticulars: '',
  payeePartyRef: '',
  payeePartyCode: '',
  payeePartyParticulars: '',
  isDefaultBankAccount: 0,
}

export const useAddMerchantBankAccounts = (
  onCloseModal: () => void
): {
  isLoading: boolean
  initialValues: AddMerchantBankAccountFormTypes
  handleSubmitAddMerchantBankAccounts: (
    values: AddMerchantBankAccountFormSubmitValuesTypes,
    actions: AddMerchantBankAccountFormSubmitActionsTypes
  ) => void
} => {
  const { traderId } = useParams()
  const queryClient = useQueryClient()
  const merchantTraderId = Number(traderId) || 0
  // MERCHANT ADD BANK ACCOUNT START
  const AddMerchantBankAccounts = useMerchantStore(
    (state) => state.addMerchantBankAccounts
  )
  const merchantBankAccountAddLoading = useMerchantStore(
    (state) => state.merchantBankAccountsAddLoading
  )
  // MERCHANT ADD BANK ACCOUNT END
  // MISC STATES START
  const [initialValues, initialValuesSet] =
    useState<AddMerchantBankAccountFormTypes>({
      ...ADDMERCHANTBANKACCOUNTSINITVAL_FORM,
      traderId: merchantTraderId,
    })
  // MISC STATES END

  const isLoading = useMemo(() => {
    return merchantBankAccountAddLoading ? true : false
  }, [merchantBankAccountAddLoading])

  const handleSubmitAddMerchantBankAccounts = useCallback(
    async (
      values: AddMerchantBankAccountFormSubmitValuesTypes,
      actions: AddMerchantBankAccountFormSubmitActionsTypes
    ) => {
      console.log("values", values)
      const sanitizedValues: AddMerchantBankAccountTypes = {
        ...values,
        bankAccountNumber: Number(values.bankAccountNumber.replace(/\D/g, '')),
      }
      try {
        await AddMerchantBankAccounts(merchantTraderId, sanitizedValues)
        toast.success('Merchant Bank Account added successful.')
        queryClient.invalidateQueries({ queryKey: ['useMerchantBankAccounts'] })
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(message.outcomeUserMessage)
      }
    },
    [AddMerchantBankAccounts]
  )

  return {
    isLoading,
    initialValues,
    handleSubmitAddMerchantBankAccounts,
  }
}
